import { fetchChallenges } from '@actions/challenges/fetchChallenges';
import {
    getChallenges,
    getChallengesFetchError,
    getChallengesIsFetching,
} from '@selectors/challenges';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFetchChallenges = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchChallenges());
    }, [dispatch]);

    const challengesObj = useSelector(getChallenges);

    const challenges = useMemo(() => {
        const arr = Object.values(challengesObj);
        return arr.sort((a, b) => a.name.localeCompare(b.name));
    }, [challengesObj]);

    const isFetching = useSelector(getChallengesIsFetching);
    const fetchError = useSelector(getChallengesFetchError);

    return { challenges, isFetching, fetchError };
};

export default useFetchChallenges;
